import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-white" data-id="element-57" data-mp="1hemfbg2decto">
      <div className="mx-auto max-w-3xl px-5 py-16 lg:py-24" style={{
      paddingTop: "20px",
      paddingBottom: "23px"
    }} data-id="element-58" data-mp="1cf0399ya32mg">
        <h2 className="text-center font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-59" data-mp="2a17ayspvpb31">
          Frequently asked questions
        </h2>
        <div className="mt-10 divide-y divide-navy/10 border-y border-navy/10" data-id="element-60" data-mp="203suit3ygmaq">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-61" data-mp="1v4g5q2tix55i" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:text-electric" data-id="element-62" data-mp="1v7c39q1glrtf">
                  <span className={cn('text-base font-semibold transition-colors duration-150 ease-out', isOpen ? 'text-electric' : 'text-navy')} data-id="element-63" data-mp="1kn71k3j56xpg">
                    {f.q}
                  </span>
                  <span className={cn('flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out', isOpen ? 'rotate-45 bg-electric text-white' : 'bg-warm text-navy/60')} data-id="element-64" data-mp="1aq2apqecqe2b">
                    <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-65" data-mp="11vnzbywxznoh" />
                  </span>
                </button>
                <div className="grid transition-[grid-template-rows] duration-200 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-66" data-mp="16q1wo6v604vs">
                  <div className="overflow-hidden" data-id="element-67" data-mp="wz77atmmgp64">
                    <div className="space-y-2 pb-5 pr-10 text-[15px] leading-relaxed text-navy/70" data-id="element-68" data-mp="iyczac3hkq7z">
                      {f.a.map(p => <p key={p} data-id="element-69" data-mp="mzq3yiuuendb">{p}</p>)}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}